import {Component, Injector, OnInit} from '@angular/core';
import {BaseComponent} from "../../base.component";
import {FilterUtil} from "../../../util/filter.util";
import {ListResponse} from "../../../network/service/list.response";
import {SnackBarUtil} from "../../../util/snack.bar.util";
import {VerifyOptions} from "../../dialog/verify/options/verify.options";
import {VerifyComponent} from "../../dialog/verify/verify.component";
import {DataResponse} from "../../../network/service/data.response";
import {RouteUtil} from '../../../util/route.util';

@Component({
  selector: 'app-domains',
  standalone: false,
  templateUrl: './domains.component.html',
  styleUrls: ['./domains.component.scss']
})
export class DomainsComponent extends BaseComponent implements OnInit {
  displayedColumns = ['Update', 'Delete', 'Title', 'DomainName'];
  displayDataSources = ['edit', 'delete', 'Title', 'DomainName'];
  displayColumnTypes = ['event', 'event', 'string', 'string'];
  displayEndPoint = [this.ServicePath.DELETE_DOMAINS, this.ServicePath.DELETE_DOMAINS, '', ''];
  domains: any = [];
  allFilters = FilterUtil.DomainsFilters;
  filters: any = {};

  constructor(injector: Injector) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  override loadOnline() {
    super.loadOnline();
    this.serviceApi.getDomains(this.tableProperties.offset, this.tableProperties.limit, undefined, undefined, {
      Filter: this.filters,
      Order: this.tableProperties.order ?? {
        Field: 'ModifyDate',
        Type: 'DESC'
      }
    }).subscribe((res: ListResponse<any>) => {
      if (res.success) {
        this.domains = res.data;
        this.tableProperties.pageLength = res.count;
        this.setListeners();
      } else {
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
  }

  override setListeners() {
    super.setListeners();
    if (this.domains) {
      for (let i = 0; i < this.domains.length; i++) {
        this.domains[i].edit = (index: number) => {
          this.onUpdateClicked(index);
        };
        this.domains[i].delete = (index: number) => {
          this.onDeleteClicked(index);
        };
      }
    }
  }

  override pageChanged(event: any) {
    super.pageChanged(event);
    this.tableProperties.offset = (event.pageIndex);
    this.loadOnline();
  }

  override onSortChanged(event: any) {
    super.onSortChanged(event);
    this.loadOnline();
  }

  onFiltersChanged(filters: any) {
    this.filters = filters;
    this.tableProperties.offset = 0;
    this.loadOnline();
  }

  onCreateClicked() {
    this.router.navigate([RouteUtil.DASHBOARD_MODULE, RouteUtil.ADD_OR_UPDATE_DOMAIN_COMPONENT]).then();
  }

  onUpdateClicked(index: number) {
    const domainId = this.domains[index]?.DomainId;
    this.router.navigate([RouteUtil.DASHBOARD_MODULE, RouteUtil.ADD_OR_UPDATE_DOMAIN_COMPONENT, {DomainId: domainId}]).then();
  }

  onDeleteClicked(index: number) {
    let verifyOptions = new VerifyOptions();
    verifyOptions.message = 'آیا از حذف درخواست خود مطمئن هستید؟';
    let verifyComponent = this.matDialog.open(VerifyComponent);
    verifyOptions.onNoClicked = () => {
      verifyComponent.close();
    };
    verifyOptions.onYesClicked = () => {
      this.serviceApi.deleteDomains(this.domains[index].DomainId).subscribe((res: DataResponse<any>) => {
        if (res.success) {
          verifyComponent.close();
          this.loadOnline();
        } else {
          SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
        }
      });
    };
    verifyComponent.componentInstance.verifyOptions = verifyOptions;
  }
}
